exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.attachable-show-component[data-v-4d9c23f0] {\n  padding: 15px 10px;\n  border: solid 1px #ccc;\n  border-radius: 4px;\n}\n.limit-text[data-v-4d9c23f0] {\n  overflow: hidden;\n  text-overflow: ellipsis;\n  display: -webkit-box;\n  -webkit-line-clamp: 2; /* number of lines to show */\n  line-clamp: 2;\n  -webkit-box-orient: vertical;\n}\n\n", ""]);

// exports
